import api from '@/api';
import type { components } from '@/api/qraft/schema';

type CourseStudyAccess = components['schemas']['CourseStudyAccess'];

/**
 * Whether the viewer may open this student's Course Study tab, which first
 * screen they get, and whether they may award a certificate.
 *
 * The first screen depends on the viewer's relationship to the student: the
 * assigned study helper, a follow-up coordinator or partner, a group
 * coordinator or an admin get Course Progression, and the student gets Courses.
 * The viewer's own profile type decides nothing, so nothing on this tab may
 * branch on `useCurrentUser().isStudent` or `.isStudyHelper`.
 *
 * One hook so the shell and both routes share a single cached query.
 */
export function useCourseStudyAccess(memberId: string | number): {
  access: CourseStudyAccess | undefined;
  isLoading: boolean;
} {
  const studentId = Number(memberId);
  const { data: access, isLoading } = api.getCourseStudyAccess.useQuery(
    { path: { student_id: studentId } },
    { enabled: Number.isInteger(studentId) && studentId > 0 },
  );

  return { access, isLoading };
}
